module.exports = __webpack_public_path__ + "img/gal_18.0d6f45a9.png";